
<template>
    <vx-card title="Selecting Values">

        <div>
            <selecting-values-default></selecting-values-default>
            <selecting-values-single-multiple-selection></selecting-values-single-multiple-selection>
            <selecting-values-tagging></selecting-values-tagging>
        </div>
    </vx-card>
</template>

<script>
import SelectingValuesDefault from './selecting-values/SelectingValuesDefault.vue';
import SelectingValuesSingleMultipleSelection from './selecting-values/SelectingValuesSingleMultipleSelection.vue';
import SelectingValuesTagging from './selecting-values/SelectingValuesTagging.vue';

export default {
    components: {
        SelectingValuesDefault,
        SelectingValuesSingleMultipleSelection,
        SelectingValuesTagging,
    },
};
</script>
